var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$vuetify.breakpoint.xs || _vm.$vuetify.breakpoint.sm)?_c('MobileAppBar'):_vm._e(),(
      _vm.$vuetify.breakpoint.md ||
        _vm.$vuetify.breakpoint.lg ||
        _vm.$vuetify.breakpoint.xl
    )?_c('AppBar'):_vm._e(),_c('router-view'),_c('SiteFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }